import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlined";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

export default function GeneralError(props) {
  const {
    message = "Error retrieving data.",
    alignment = "center",
    title = "Error",
  } = props;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ErrorOutlineIcon
          color="primary"
          sx={{ width: 100, height: 100, py: 1 }}
        />
      </Box>
      <Box sx={{ textAlign: "center", pb: 1 }}>
        <Typography align={alignment} variant="h6" sx={{ mb: 2 }}>
          {title ? title : "Error"}
        </Typography>
        <Typography color="textSecondary" align={alignment}>
          {message ? message : "Error retrieving data."}
        </Typography>
      </Box>
    </>
  );
}
